/* eslint-disable no-unused-vars */
enum RoutesIndexes {
    WRONG_USERNAME_OR_PASSWORD = 1,
    CANNOT_CREATE_USER = 2,
    CANNOT_CREATE_VIDEO = 3,
}

export default RoutesIndexes;
